import { ResellerService } from '@/services/reseller.service'

const state = {
    dialog: false,
    loading: false,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    judul: '',
    color: '',
    list: []
};


const actions = {
    OpenDialogForm({ commit }) {
        commit('opendialog');
    },
    closeDialog({ commit }) {
        commit('closedialog');
    },
    list({ commit }) {

        ResellerService.list().then(data => {
            //console.log(data.data[0]);
            commit('addResponseApp', data);
        }, error => {
            console.log(error);
        });
    },
    Delete({ dispatch, commit }, delete_id) {
        ResellerService.hapus(delete_id).then(data => {
            dispatch('alert/success', 'Delete data Successfully', { root: true });
            commit('ShowAdd', data);
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
    Add({ dispatch, commit }, newData) {
        ResellerService.add(newData)
            .then(data => {
                dispatch('alert/success', 'Add data Successfully', { root: true });
                commit('ShowAdd', data);
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    Edit({ dispatch, commit }, editdata) {
        ResellerService.edit(editdata)
            .then(data => {
                dispatch('alert/success', 'Edit data Successfully', { root: true });
                commit('ShowAdd', data);
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    }
}


const mutations = {
    ShowAdd(state, data) {
        console.log(data);
        state.dialog = false;
    },
    addResponseApp(state, apps) {
        state.list = []
        state.list = apps.data;
        //console.log(state.applist[0]);
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}


export const Reseller = {
    namespaced: true,
    state,
    actions,
    mutations
};
